module.exports = __webpack_public_path__ + "asset/image-Wuestion-Mark-4258366eaa666e99.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/Wuestion-Mark.svg
// module id = l9ut
// module chunks = 0